import React from 'react';
import moment from "moment/moment";

const ProblemUserDateTemplate = (props) => {
    if (!props[props.column.field]) {
        return null;
    }

    const date = moment(props[props.column.field]).format("DD.MM.YYYY HH:mm");

    return (
        <div>
            {date}
        </div>
    );
};

export default ProblemUserDateTemplate;